import { z, ZodType } from 'zod';

export type BetResponse = {
	status: boolean;
	balance: number;
	msg: string;
	provablyFair: string;
	amount: number;
};

export const betResponseSchema: ZodType<BetResponse> = z.object({
	status: z.boolean(),
	balance: z.number(),
	msg: z.string(),
	provablyFair: z.string(),
	amount: z.number(),
});
